import React from 'react';

import MenuDesktop from 'components/Desktop/Menu';
import MenuMobile from 'components/Mobile/Menu';
import LoadingIcon from './LoadingIcon';
import styles from './SuspensePlaceholder.module.css';

interface Props {
  menu: 'desktop' | 'mobile';
}

const SuspensePlaceholder = ({ menu }: Props) => {
  return (
    <>
      {menu === 'desktop' && <MenuDesktop />}
      {menu === 'mobile' && <MenuMobile />}
      <div className={styles.wrapper}>
        <LoadingIcon />
      </div>
    </>
  );
};

export default SuspensePlaceholder;
